var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.784 0a3.784 3.784 0 000 7.569H6.83a3.783 3.783 0 003.3 1.931h4.966a3.784 3.784 0 100-7.569H12.05A3.783 3.783 0 008.75 0H3.784zm6.302 1.931A2.274 2.274 0 008.75 1.5H3.784a2.284 2.284 0 000 4.569h2.577a3.784 3.784 0 013.725-4.138zM7.872 6.07a2.284 2.284 0 012.257-2.638h.878A2.284 2.284 0 018.75 6.069h-.878zm.921 1.5a3.785 3.785 0 003.725-4.138h2.577a2.284 2.284 0 110 4.569h-4.966c-.499 0-.96-.16-1.336-.431z",
    clipRule: "evenodd"
  })));
}

export default SvgClipboard;